'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupCardCta = undefined;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignupCardCta = exports.SignupCardCta = function SignupCardCta(_ref) {
  var copy = _ref.copy,
      formId = _ref.formId,
      isDisabled = _ref.isDisabled,
      isSubmitting = _ref.isSubmitting;
  return _react2.default.createElement(
    'button',
    {
      className: (0, _classnames2.default)({
        'bt bt--primary bt--lg bt--width-full': true,
        'bt--waiting': isSubmitting
      }),
      type: 'submit',
      disabled: isSubmitting || isDisabled,
      form: formId
    },
    copy || _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'signup-card.general.action',
      defaultMessage: 'Continue'
    })
  );
};

SignupCardCta.propTypes = {
  copy: _propTypes2.default.node,
  formId: _propTypes2.default.string,
  isDisabled: _propTypes2.default.bool,
  isSubmitting: _propTypes2.default.bool
};